const cs = require('../i18n/cs/messages.js')
const csLocaleData = require('date-fns/locale/cs').default
const en = require('../i18n/en/messages.js')
const enLocaleData = require('date-fns/locale/en-GB').default
module.exports = {  
    cs: {    
        catalog: cs,  
        currency: 'CZK',  
        default: true,   
        flag: '\u{1F1E8}\u{1F1FF}', 
        locale: 'Česky',   
        localeData: csLocaleData, 
        localeShort: 'CZ',   
        path: 'cs',  
    },  
    en: {    
         catalog: en,  
         currency: 'EUR',  
         flag: '\u{1F1EC}\u{1F1E7}', 
         locale: 'English',  
         localeData: enLocaleData,  
         localeShort: 'EN',   
         path: 'en',  
        }
    ,}